/** Snow on up-facing surfaces of `snow`-marked meshes, scaled by WorldState.memory.snowCover. */
export const SNOW_UNIFORMS = { uSnowCover: { value: 0 } };

export const SNOW_VERT_PARS = 'varying vec3 vSnowNormal;';
export const SNOW_VERT = 'vSnowNormal = normalize(mat3(modelMatrix) * objectNormal);';
export const SNOW_FRAG_PARS = 'uniform float uSnowCover;\nvarying vec3 vSnowNormal;';
export const SNOW_FRAG_COLOR =
  'float snowMask = smoothstep(0.35, 0.75, normalize(vSnowNormal).y) * uSnowCover;\ndiffuseColor.rgb = mix(diffuseColor.rgb, vec3(0.93, 0.95, 0.98), snowMask);';
export const SNOW_FRAG_ROUGHNESS = 'roughnessFactor = mix(roughnessFactor, 0.75, snowMask);';
